module.exports = __webpack_public_path__ + "media/notificacion.fdada94d.mp3";